module.exports = __webpack_public_path__ + "static/media/vu-anh-TiVPTYCG_3E-unsplash.0c0f853c.png";